// web/mocks/react-native-permissions.web.js
export const PERMISSIONS = {};
export const RESULTS = {
  UNAVAILABLE: 'unavailable',
  BLOCKED: 'blocked',
  DENIED: 'denied',
  GRANTED: 'granted',
  LIMITED: 'limited',
};

export const request = () => Promise.resolve(RESULTS.GRANTED);
export const check = () => Promise.resolve(RESULTS.GRANTED);
export const requestMultiple = () => Promise.resolve({});

export default {
  PERMISSIONS,
  RESULTS,
  request,
  check,
  requestMultiple,
};